import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sedaliaMOConfig } from "./data";

export default function SedaliaMOPage() {
  return <CityPageTemplate config={sedaliaMOConfig} />;
}